import axios from "axios";

const api = process.env.NODE_ENV === "development"
  ? "http://localhost:3000/"
  : "https://vd7p0j8os9.execute-api.eu-central-1.amazonaws.com/prod/";

const instance = axios.create({
  baseURL: api,
});

instance.interceptors.response.use(
  (response) => {
    return response;
  },
  (err) => {
    console.error("API Error:", err);
    if (err?.response?.status === 401) {
      console.log(err?.response);
    }
    return Promise.reject(err);
  }
);

export { instance };
